<template>
<div
  class="card"
  v-if="!loading"
>
  <div class="card-header">
    <h4>Arquivos para este ticket</h4>
  </div>
  <div class="card-content">
    <div class="row">
      <div class="col-xs-12">
      <div
        class="img-attch-ticket"
        v-for="(doc, i) in docs"
        :key="i"
      >
        <div
          class="attachment-file"
          v-for="(att, j) in Object.keys(doc._attachments)"
          :key="j"
        >
          <a
            :href="getHref(doc._id, att)"
            target="_blank"
          >
          {{ att }}
          </a>
        </div>
      </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import connections from '../../../config/connections'

export default {
  name: 'DocumentsTicketCard',
  props: ['ticketId'],
  mounted () {
    this.fetchDocs({ where: { referenceId: this.ticketId, collection: { $exists: true } }, limit: 9999 })
      .then(res => {
        this.docs = res
      })
  },
  data () {
    return {
      docs: []
    }
  },
  computed: {
    ...mapGetters('docs', ['loading'])
  },
  methods: {
    ...mapActions('docs', { fetchDocs: 'fetchAll' }),
    getHref (id, att) {
      return connections['docs'].host + '/' + connections['docs'].db + '/' + id + '/' + att
    }
  }
}
</script>

<style scoped>
  .img-attch-ticket {
    display: flex;
    flex-wrap: wrap;
  }
  .attachment-file {
    padding: 0.5em 1em;
    margin: 0.5em 0.5em;
    border-radius: 0.3em;
    border: 1px solid #102729 ;
  }
  .attachment-file a {
    color: black;
  }
</style>



// WEBPACK FOOTER //
// src/components/Trg/Tickets/DocumentsTicketCard.vue